/** @format */

import { includes, intersection, isArray, isEmpty } from "lodash";

export const checkIncludes = (array, values) => {
  if (isArray(values)) {
    return !isEmpty(intersection(array, values));
  } else {
    return includes(array, values);
  }
};
